module.exports = __webpack_public_path__ + "static/media/thumbnail_logo_orange.735403d2.png";